import classnames from "classnames";
import React from "react";
import MiniProductsCarousel from "src/components/MiniProductsCarousel";
import { getSmallerProductImageSrc } from "src/services/image.service";
import { mapPrismicProductToProduct } from "src/services/mapperService";
import { translate } from "src/services/translation.service";
import { media } from "src/theme";
import { IProduct } from "src/types/product";
import styled from "styled-components";

import { LinkButton, RichTextBlock, Slice } from "../components";
import { ISliceSliderProducts } from "../types";

const TextBlock = styled(RichTextBlock)`
  text-align: center;
`;

const StyledSlice = styled(Slice)`
  text-align: center;
`;

const Slider = styled(MiniProductsCarousel)`
  .product-name-link,
  .product-name {
    width: 100%;
  }

  && .product-item > div {
    align-items: center;

    ${media.tablet} {
      align-items: center;
    }
  }
`;

export const SliderProducts = ({
  slice_type,
  primary,
  items,
}: ISliceSliderProducts): JSX.Element | null => {
  const {
    class_name: className,
    background_color: backgroundColor,
    background_image: backgroundImage,
    max_slides: maxSlides,
    rich_text_top: richTextTop,
    rich_text_bottom: richTextBottom,
    link_url: url,
    link_label: label,
  } = primary;

  const products: IProduct[] = mapPrismicProductToProduct(items).map(
    (product) => {
      // replace product image by a pre-existing smaller version (169x225)
      product.image = getSmallerProductImageSrc(product.image);

      return product;
    }
  );

  return (
    <StyledSlice
      className={classnames("slice-slider-products", className)}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      noGutter
    >
      <TextBlock className="slider-products-text-intro" render={richTextTop} />
      <Slider products={products} maxSlides={maxSlides} />
      <LinkButton to={url}>
        {label || translate("global.discoverSelection")}
      </LinkButton>
      <TextBlock
        className="slider-products-text-outro"
        render={richTextBottom}
      />
    </StyledSlice>
  );
};
